import { Check, CreditCard } from 'lucide-react';
import styles from './paymentProgress.module.css';

export default function PaymentProgress({ stage }: { stage: 'checking' | 'reserving' | 'payment' }) {
  return (
    <div className={`${styles.scene} text-primary`} data-stage={stage} aria-hidden="true">
      <div className={styles.ticket}>
        <div className={styles.heading}><span /> <span /></div>
        <div className={styles.slots}>
          {[0, 1, 2].map(index => <span key={index} className={styles.slot}><span /></span>)}
          <span className={styles.selection} />
        </div>
        <div className={styles.divider} />
        <div className={styles.details}><span /><span /></div>
        <span className={styles.confirmation}><Check size={18} strokeWidth={2.5} /></span>
      </div>
      <div className={styles.card}><CreditCard size={28} strokeWidth={1.6} /></div>
    </div>
  );
}